// Mock data for KMH & Associates landing page

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Team', href: '#team' },
  { label: 'Insights', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

export const heroSlides = [
  {
    eyebrow: 'Compliance Reimagined',
    title: 'Shatter the misconception that compliance is a cost-burden.',
    description:
      'Learn how addressing 3 key areas can convert your costs into revenue and build a fortress around your enterprise.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/phqgqmyu_WhatsApp%20Image%202026-07-01%20at%2012.38.39%20PM.jpeg',
  },
  {
    eyebrow: 'Revenue, Not Cost',
    title: 'Meeting every compliance is a revenue-generating activity, not a cost-adding activity.',
    description:
      'Discover the 3 areas that your business needs to work on to transform compliance into a powerful growth engine.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/fx3nnye4_WhatsApp%20Image%202026-07-01%20at%2012.38.40%20PM%20%281%29.jpeg',
  },
  {
    eyebrow: 'A New Perspective',
    title: 'What if compliance was the most profitable decision you ever made?',
    description:
      'We help India\u2019s most ambitious businesses turn complex regulation into measurable competitive advantage.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/ghm77sk0_WhatsApp%20Image%202026-07-01%20at%2012.38.40%20PM.jpeg',
  },
];

export const problems = [
  {
    icon: 'Eye',
    title: 'Lack of Awareness',
    description:
      'They overlook government threats due to lack of awareness, exposing their company to significant risks.',
  },
  {
    icon: 'Network',
    title: 'Fragmented Approach',
    description:
      'They seek advice from different sources for different requirements, resulting in disjointed strategies.',
  },
  {
    icon: 'LayoutGrid',
    title: 'No Holistic Framework',
    description:
      'They lack a holistic plan, which results in the absence of a unified approach against a range of risks.',
  },
  {
    icon: 'ShieldAlert',
    title: 'Lack of Confidence',
    description:
      'They lack confidence, which impedes them from effectively addressing and overcoming issues.',
  },
  {
    icon: 'TrendingDown',
    title: 'Costly Oversight',
    description:
      'They view compliance as an extra cost, which leads to expensive fines and even shutdowns.',
  },
];

export const stats = [
  { value: '70%', label: 'of business owners cannot bullet-proof their company from government threats' },
  { value: '500+', label: 'businesses empowered across diverse industries since 2020' },
  { value: '6', label: 'core verticals of compliance & advisory under one roof' },
  { value: '100%', label: 'commitment to sustainable, personalised solutions' },
];

export const serviceCategories = [
  {
    id: 'posh',
    number: '01',
    badge: 'PoSH Compliance',
    title: 'Prevention of Sexual Harassment',
    headline: 'Did you know that a lack of implementation of PoSH can get your license revoked?',
    description:
      'Build a safe, inclusive and compliant workplace with policy frameworks engineered around the latest amendments to the PoSH Act.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/ghm77sk0_WhatsApp%20Image%202026-07-01%20at%2012.38.40%20PM.jpeg',
    facts: [
      {
        title: 'Gender Neutral',
        text: 'While the law was created to address sexual harassment faced by women, it applies to everyone in the workplace.',
      },
      {
        title: 'Most Workplaces Apply',
        text: 'Organisations with over 10 employees, regardless of gender composition, need to comply with PoSH.',
      },
      {
        title: 'Mandatory Training',
        text: 'Organisations are required to conduct awareness programmes and training sessions on PoSH at regular intervals.',
      },
    ],
    offerings: [
      { title: 'Policy Review & Alignment', text: 'We review your existing PoSH policy to ensure it complies with the latest Act provisions and best practices.' },
      { title: 'Internal Committee Support', text: 'We assist in establishing a compliant IC adhering to the Act\u2019s composition and representation.' },
      { title: 'Record Management', text: 'We advise on maintaining proper records of PoSH complaints and inquiries as mandated by the Act.' },
      { title: 'External Liaison', text: 'We help in identifying external IC members, while preserving the IC\u2019s authority over final selection.' },
    ],
  },
  {
    id: 'secretarial',
    number: '02',
    badge: 'Secretarial',
    title: 'Secretarial Compliance',
    headline: 'Is compliance slowing you down?',
    description:
      'Our expert secretarial services keep your business running smoothly while satisfying every statutory expectation with surgical precision.',
    image: 'https://images.unsplash.com/photo-1681164315393-8d2850f570fa?auto=format&fit=crop&w=1400&q=80',
    offerings: [
      { title: 'Statutory Filings & Recordkeeping', text: 'Ensure accuracy and timeliness with our meticulous filing and record management.' },
      { title: 'Board & Meeting Administration', text: 'Seamless board meeting support that powers effective decision making.' },
      { title: 'Corporate Governance', text: 'Navigate the complexities of corporate governance with our deep expertise.' },
      { title: 'Stakeholder Liaison', text: 'Bridge the gap with effective channels of communication across stakeholders.' },
    ],
  },
  {
    id: 'fundraising',
    number: '03',
    badge: 'Fundraising',
    title: 'Fundraising & Compliance',
    headline: 'Confused and worried about fundraising rules?',
    description:
      'We bridge the gap between impact and compliance, giving founders confidence at every funding milestone.',
    image: 'https://images.unsplash.com/photo-1756885465373-bce82fd5c944?auto=format&fit=crop&w=1400&q=80',
    offerings: [
      { title: 'Fundraising Documents', text: 'Secure your capital with our expert review of fundraising materials.' },
      { title: 'Governance Considerations', text: 'Navigate leadership structure for a well-governed organisation.' },
      { title: 'Tax Compliance', text: 'Maximise fundraising benefits with strategic tax guidance from our experts.' },
      { title: 'AML / KYC Compliance', text: 'Stay transparent and secure with anti-money laundering and KYC compliance expertise.' },
    ],
  },
  {
    id: 'nbfc',
    number: '04',
    badge: 'NBFC',
    title: 'NBFC Compliance',
    headline: 'Want to simplify your NBFC journey?',
    description:
      'Extensive support for flawless NBFC compliance \u2014 from licensing to regulatory reporting under the RBI framework.',
    image: 'https://images.pexels.com/photos/19747906/pexels-photo-19747906.jpeg?auto=compress&w=1400&q=80',
    offerings: [
      { title: 'Compliance Monitoring', text: 'Stay ahead of regulations with our expert monitoring and proactive alerts.' },
      { title: 'Regulatory Returns', text: 'Ensure timely and accurate filings with our efficient return management system.' },
      { title: 'Corporate Governance', text: 'Build a well-structured and compliant company with our governance frameworks.' },
      { title: 'Risk Management', text: 'Proactively identify and mitigate risks for sustainable growth and a secure future.' },
    ],
  },
  {
    id: 'fema',
    number: '05',
    badge: 'FEMA',
    title: 'FEMA Compliance',
    headline: 'Navigate the currents of FEMA with confidence.',
    description:
      'Our experts orchestrate seamless cross-border transactions with complete adherence to the Foreign Exchange Management Act.',
    image: 'https://images.unsplash.com/photo-1771244688590-1e481dba1b5a?auto=format&fit=crop&w=1400&q=80',
    offerings: [
      { title: 'Planning & Preparedness', text: 'Be ready for anything with a robust plan to keep your business running.' },
      { title: 'Regulatory Compliance', text: 'Navigate legal complexities confidently by adhering to every regulation.' },
      { title: 'Recordkeeping & Documentation', text: 'Maintain a secure and organised recordkeeping system for absolute peace of mind.' },
      { title: 'Advisory & Strategy', text: 'Strategic foreign exchange advisory tailored for cross-border ambitions.' },
    ],
  },
  {
    id: 'llp',
    number: '06',
    badge: 'LLP',
    title: 'LLP Compliance',
    headline: 'LLP regulations got you stuck?',
    description:
      'Our expert guidance keeps you stress-free and 100% compliant, from registration to annual statutory obligations.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/fx3nnye4_WhatsApp%20Image%202026-07-01%20at%2012.38.40%20PM%20%281%29.jpeg',
    offerings: [
      { title: 'Incorporation & Registration', text: 'Launch your LLP smoothly with our expert registration and setup service.' },
      { title: 'Statutory Registers', text: 'Stay organised and compliant with our efficient statutory register management.' },
      { title: 'Annual Returns & KYC', text: 'Ensure timely filings and KYC adherence with our hassle-free support.' },
      { title: 'LLP Agreement Compliance', text: 'Operate seamlessly with guidance on your LLP agreement and regulations.' },
    ],
  },
  {
    id: 'entity',
    number: '07',
    badge: 'Entity Formation',
    title: 'Fast Track Your Business Launch',
    headline: 'Fast-track your business launch.',
    description:
      'Our experts handle entity formation efficiently and accurately, so you can focus on building something meaningful.',
    image: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/phqgqmyu_WhatsApp%20Image%202026-07-01%20at%2012.38.39%20PM.jpeg',
    offerings: [
      { title: 'Entity Selection & Guidance', text: 'Choose the right business structure for your goals with our expertise.' },
      { title: 'Incorporation & Registration', text: 'Launch your business seamlessly with efficient incorporation and registration.' },
      { title: 'Regulatory Compliance', text: 'Ensure a smooth start by meeting all the incorporation regulations confidently.' },
      { title: 'Documentation & Records', text: 'Simplify record management and ensure compliance through our system.' },
    ],
  },
];

export const services = serviceCategories.map((s) => ({
  id: s.id,
  title: s.title,
  badge: s.badge,
  summary: s.description,
}));

export const partners = [
  {
    name: 'Krishnamurthy Hegde',
    role: 'Founding Partner',
    image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/vpnntwiw_WhatsApp%20Image%202026-08-12%20at%205.28.20%20PM.jpeg',
  },
  {
    name: 'Manjunatha Hegde',
    role: 'Founding Partner',
    image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/facm106f_WhatsApp%20Image%202026-08-12%20at%205.25.22%20PM.jpeg',
    isolated: true,
  },
  {
    name: 'Vijaya Rao',
    role: 'Strategic Partner & Mentor',
    image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/0gb9fukp_WhatsApp%20Image%202026-08-12%20at%205.37.02%20PM.jpeg',
  },
];

export const associates = [
  { name: 'Disha Puranik', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/zj8jy8hd_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%286%29.jpeg' },
  { name: 'Kavya Bhat', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/hlqtcy0c_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%2811%29.jpeg' },
  { name: 'Ishwari K S', role: 'Finance Manager', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/pbqr0mfn_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%287%29.jpeg' },
  { name: 'Ashritha E B', role: 'Associate', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/5jy5zymi_WhatsApp%20Image%202026-08-12%20at%205.37.03%20PM.jpeg' },
  { name: 'Bhavya Hegde', role: 'Compliance Manager', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/j464fmff_WhatsApp%20Image%202026-08-12%20at%205.37.12%20PM.jpeg' },
  { name: 'Chidghan Hegde', role: 'Compliance Manager', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/h8i5qb1l_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%281%29.jpeg' },
  { name: 'Sindhu Bhat', role: 'Compliance Lead', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/gb008r76_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%282%29.jpeg' },
  { name: 'Pradeep N S', role: 'Compliance Lead', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/ljbffevk_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%283%29.jpeg' },
  { name: 'Swathi S Ganesh', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/zf54uo2t_WhatsApp%20Image%202026-08-12%20at%205.39.26%20PM.jpeg' },
  { name: 'Shreevatsa Hegde', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/f49d4jns_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM.jpeg' },
  { name: 'Vara Prasad. T', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/z8qoqlwz_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%284%29.jpeg' },
  { name: 'Nagashree S Hegde', role: 'Compliance Executive', image: 'https://customer-assets-0z36b82j.emergentagent.net/job_premium-services-hub-10/artifacts/tx93qgbu_WhatsApp%20Image%202026-08-12%20at%205.37.06%20PM%20%285%29.jpeg' },
];

export const keyAreas = [
  {
    number: '01',
    title: 'Awareness',
    text: 'Information is power. Being aware of the regulations that affect your business is the first step to making it successful in the long run.',
    icon: 'Lightbulb',
  },
  {
    number: '02',
    title: 'Right People',
    text: 'Having the right people on board can make all the difference. Leverage their expertise to navigate the complexities of compliance.',
    icon: 'Users',
  },
  {
    number: '03',
    title: 'Execution',
    text: 'Even with the right knowledge and the right people, everything will fail without action. Implement plans and strategies that get results.',
    icon: 'Rocket',
  },
];

export const company = {
  name: 'KMH & Associates',
  short: 'KMH',
  logo: 'https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/y2bxf54d_WhatsApp%20Image%202026-07-01%20at%2012.50.13%20PM.jpeg',
  phone: '+91 82774 72477',
  email: 'contact@kmhassociates.in',
  address: 'Bengaluru, Karnataka, India',
  founded: '2020',
  tagline: 'Company Secretarial \u00b7 Business Advisory',
};
